//Dependencies
import React from "react";
import Swal from "sweetalert2";
// Components from Dependency

// Components
import { HeadingTitle } from "../../components/solicitudViolencia/HeadingTitle";
import { SolicitudViolenciaForm } from "../../components/solicitudViolencia/SolicitudViolenciaForm/SolicitudViolenciaForm";

//Styles
import "../../styles/solicitudViolencia/solicitudViolencia.css";

//Componente para la ruta solicitudViolencia
const SolicitudViolenciaScreen = () => {
  // Alerta que se ejecuta al cargar la página
  Swal.fire({
    title: "Alerta de seguridad",
    html: "<p>¿Le preocupa que alguien observe el contenido de este sitio?</p> <p><strong>Haga clic en el botón Salir «X» en cualquier momento para salir de esta página inmediatamente.</strong></p> <p>Al salir se borrará toda la información capturada.</p>",
    confirmButtonText: "Esta Bien",
  });

  return (
    <main>
      <HeadingTitle />
      <SolicitudViolenciaForm />
    </main>
  );
};

export { SolicitudViolenciaScreen };
